// extracted by mini-css-extract-plugin
module.exports = {"updatebar":"UpdateBar-styles-module--updatebar--2zStY"};